import { Link } from "react-router-dom";
import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
export default function HomeThreeBanner(){
    
    const [isOpen, setIsOpen] = useState(false);
    const openModal = () => setIsOpen(!isOpen);
    
    return(
		<>
			<ModalVideo channel='youtube' isOpen={isOpen} videoId='vWLcyFtni6U' onClose={() => { openModal(); }} />
		
			<div id="slider-one" className="main-slider-area">
				<div className="slider-bg-three">
					<div className="container">                
						<div className="row align-items-center justify-content-center">
							<div className="col-lg-12">
								<div className="slider__content3 text-center">
									<h5 className="fw-normal text-white mb-15">We provide the most responsive and
										functional
										IT design</h5>
									<h1 className="main-title-three mb-50">Digital Solutions</h1>
									<div className="btn-list d-sm-flex align-items-center justify-content-center">
										<Link className="theme_btn" to="/contact">Free Consultation</Link>
										<div className="video-slide home3 d-flex align-items-center">
										<Link className="popup-video" onClick={() => { openModal(); }}><i className="fa fa-play"></i></Link>
											<h6>How It Works?</h6>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
    )
}